import React, {Component} from 'react';
import queryString from 'query-string'

import i18n from '../resources/i18n';
import {properties} from '../resources/properties.js';

declare var M;
declare var ol;

class Map extends Component {
  constructor(props) {
    super(props);
    this.numCapas = 1;
    this.state = {
      map: null,
      coordinates: null,
      isLoaded: true,
      isTranslated: true,
    };
  }
  setStateGlobal = (state, event, value) => {
    const {setParentState} = this.props;
    setParentState(state, event);
  }
  setModal = (mapa, state) => {
    const {setModal} = this.props;
    setModal(mapa, state);
  }

  setModalLoading = (state) => {
    this.setState({isTranslated: false});
  }

  componentDidMount() {
    let drawFeatures = null;
    const {
      M,
      centerX,
      centerY,
      parentState,
      pluginList,
      pluginEdition,
      isSimple,
      baseLayer,
      activeServices
    } = this.props;

    this.coordinates = null;
    if (parentState.mapa !== null && parentState.mapa !== undefined) {
      let parentStateMapLayerDraw = parentState.mapa.getImpl().getLayers().find(layer => layer.name === '__draw__');
      if (parentStateMapLayerDraw !== undefined && parentStateMapLayerDraw.length !== 0) {
        drawFeatures = parentStateMapLayerDraw.getFeatures();
      } else {
        drawFeatures = [];
      }
    }

    let capasAnadir = [];
    let capasAnadirImage = [];
    let InsertPhotoFeatures = [];
    if (this.props.parentState.eventKey !== null && this.props.parentState.eventKey !== undefined) {
      window.mapJs.getPlugins().find(p => p.name === 'Mapaalacarta').unByKey('dragend', this.props.parentState.eventKey);
    }else{//eventKey is always undefined, so search the keys of the plugin and remove them.
      if(window.mapJs && window.mapJs.getPlugins().find(p => p.name === 'Mapaalacarta').eventsManager_.events_.dragend){
        window.mapJs.getPlugins().find(p => p.name === 'Mapaalacarta').eventsManager_.events_.dragend.forEach(k=>window.mapJs.getPlugins().find(p => p.name === 'Mapaalacarta').unByKey('dragend', k.eventKey_));
      }
    }
    if (window.mapJs) {
      window.mapJs.getLayers().forEach((layer) => {
        if (layer.getImpl().getOL3Layer().get("vendor.mapaalacarta.selectable") === true) {
          capasAnadir.push(layer);
        }
      });

      if(!isSimple){
        let auxPop = capasAnadir.pop();
        if(auxPop) InsertPhotoFeatures = auxPop.getFeatures(); //Elimina la capa de InsertPhoto
        window.mapJs.getMapImpl().getLayers().getArray().forEach((layer) => {
          if (layer.get("vendor.mapaalacarta.imageLayer") === true) {
            capasAnadirImage.push(layer);
          }
        });
      }
      window.mapJs.destroy();
    }

    this.valuesApi = queryString.parse(this.props.location.search);
    const crs = this.valuesApi.CRS || this.valuesApi.crs;
    const bbox = this.valuesApi.BBOX || this.valuesApi.bbox;
    this.bboxApi = this.valuesApi !== '' && bbox !== undefined ? bbox.split(','): [];
    let mapBaseLayer;
    if(baseLayer === 'BOTH'){
      mapBaseLayer = parentState.seleccionadoProductoSeries==='Foto'
        ? [ 'TMS*Orto*https://tms-pnoa-ma.idee.es/1.0.0/pnoa-ma/{z}/{x}/{-y}.jpeg*true*false', 'TMS*MTN*https://tms-mapa-raster.ign.es/1.0.0/mapa-raster/{z}/{x}/{-y}.jpeg*false*false*16' ]
        : [ 'TMS*MTN*https://tms-mapa-raster.ign.es/1.0.0/mapa-raster/{z}/{x}/{-y}.jpeg*true*false*16', 'TMS*Orto*https://tms-pnoa-ma.idee.es/1.0.0/pnoa-ma/{z}/{x}/{-y}.jpeg*false*false' ];

    }else{
      mapBaseLayer = baseLayer === 'PNOA' ? ['TMS*Orto*https://tms-pnoa-ma.idee.es/1.0.0/pnoa-ma/{z}/{x}/{-y}.jpeg*true*false'] : ['TMS*MTN*https://tms-mapa-raster.ign.es/1.0.0/mapa-raster/{z}/{x}/{-y}.jpeg*true*false*16'];
    }
    if (this.bboxApi.length === 4) {
      if (crs !== undefined){
        declare var ol;
        this.bboxApi = this.bboxApi.map((coordinate) => {return parseInt(coordinate)});
        const originProj = ol.proj.get(crs);
        const destProj = ol.proj.get('EPSG:3857');
        const coordinatesTransform = ol.proj.transformExtent(this.bboxApi, originProj, destProj);
        this.bboxApi = coordinatesTransform;
      }
      window.mapJs = M.map({
        container: 'map',
        layers: mapBaseLayer,
        projection: "EPSG:3857*m",
        controls: [""],
        bbox: this.bboxApi,
        zoom: 10,
        maxZoom: 18,
      });
    } else {
      window.mapJs = M.map({
        container: 'map',
        layers: mapBaseLayer,
        projection: "EPSG:3857*m",
        controls: [""],
        zoom: 10,
        maxZoom: 18,
        center: {
          x: centerX,
          y: centerY
        }
      });
    }

    let savedCredits = {}; //Credits are lost in this next addLayer, so they will be saved prior and added later
    capasAnadir.forEach(l => {
      if(l.impl_.ol3Layer.values_.credits){
        savedCredits[l.impl_.name] = l.impl_.ol3Layer.values_.credits;
      }
    });
    window.mapJs.addLayers(capasAnadir);
    capasAnadir.forEach((layer) => {
      layer.getImpl().getOL3Layer().set('vendor.mapaalacarta.selectable', true);
      let returnableCredits = savedCredits[layer.impl_.name];
      if(returnableCredits){
        layer.impl_.ol3Layer.values_.credits = returnableCredits;
      }
    });

    capasAnadirImage.forEach((layer) => {
      window.mapJs.getMapImpl().addLayer(layer);
    });

    const URL_25 = document.location.origin + "/" + process.env.REACT_APP_CONTEXT + "/layers/HOJAS_MTN.json";
    const URL_50 = document.location.origin + "/" + process.env.REACT_APP_CONTEXT + "/layers/HOJAS_MTN50.json";
    const PNOA = document.location.origin + "/" + process.env.REACT_APP_CONTEXT + "/layers/PNOA.geojson";
    const regexp = /([a-zA-Z0-9@%._+~#=])\/\//g;

    /* ----------------- Borrar estas 3 lineas cuando estén las traducciones en el API CNIG, las añadimos así mientras tanto*/
    M.language.addTranslation('ca', undefined);
    M.language.addTranslation('eu', undefined);
    M.language.addTranslation('gl', undefined);

    M.language.setLang(['en', 'es', 'ca', 'eu', 'gl'].includes(i18n.language) ? i18n.language : 'es');
    M.proxy(false);
    const layer25 = new M.layer.GeoJSON({
      name: "capaJson",
      url: URL_25.replace(regexp, '$1/'),
      extract: true
    });

    layer25.setVisible(false);
    layer25.setStyle(new M.style.Polygon({
      stroke: {
        color: '#000000'
      },
      fill: {
        color: 'white',
        opacity: 0.01
      }
    }));

    const layer50 = new M.layer.GeoJSON({
      name: "capaJson50",
      url: URL_50.replace(regexp, '$1/'),
      extract: true
    });
    layer50.setVisible(false);
    layer50.setStyle(new M.style.Polygon({
      stroke: {
        color: '#000000'
      },
      fill: {
        color: 'white',
        opacity: 0.01
      }
    }));
    const layerPNOA = new M.layer.GeoJSON({
      name: "capaHojaPNOA",
      url: PNOA.replace(regexp, '$1/'),
      extract: true
    });
    layerPNOA.setVisible(false);
    layerPNOA.setStyle(new M.style.Polygon({
      stroke: {
        color: '#000000'
      },
      fill: {
        color: 'white',
        opacity: 0.01
      }
    }));
    // Inject changed code for Chrome performance, not posible to unify because of "this"
    layer25.impl_.addFeatures = function(t,e){var r=this;r.features_.length?t.forEach((function(t){var e=r.features_.find((function(e){return e.equals(t)}));M.utils.isNullOrEmpty(e)&&r.features_.push(t)})):(r.features_=t);e&&r.updateLayer_();r.redraw()};
    layer50.impl_.addFeatures =  function(t,e){var r=this;r.features_.length?t.forEach((function(t){var e=r.features_.find((function(e){return e.equals(t)}));M.utils.isNullOrEmpty(e)&&r.features_.push(t)})):(r.features_=t);e&&r.updateLayer_();r.redraw()};
    layerPNOA.impl_.addFeatures = function(t,e){var r=this;r.features_.length?t.forEach((function(t){var e=r.features_.find((function(e){return e.equals(t)}));M.utils.isNullOrEmpty(e)&&r.features_.push(t)})):(r.features_=t);e&&r.updateLayer_();r.redraw()};
    //
    window.mapJs.addLayers(layer25);
    window.mapJs.addLayers(layer50);
    window.mapJs.addLayers(layerPNOA);

    const grid25 = new M.layer.WMS({
      url: 'https://www.ign.es/wms-inspire/cuadriculas?',
      name: 'cuadricula-mtn25-actual',
      legend: 'cuadricula-mtn25-actual',
      tiled: false,
    }, {});
    grid25.setVisible(false);
    window.grid25Layer = grid25;
    window.mapJs.addWMS(grid25);
    const grid50 = new M.layer.WMS({
      url: 'https://www.ign.es/wms-inspire/cuadriculas?',
      name: 'cuadricula-mtn50-actual',
      legend: 'cuadricula-mtn50-actual',
      tiled: false,
    }, {})
    grid50.setVisible(false);
    window.grid50Layer = grid50;
    window.mapJs.addWMS(grid50);

    if (activeServices !== undefined && Object.keys(activeServices).length > 0){
      for (let [layerName, layerUrl] of Object.entries(activeServices)){
        const newService = new M.layer.WMS({
          url : layerUrl,
          name : layerName,
          legend: layerName,
          tiled: false,
        }, {});
        window.mapJs.addLayers(newService);
      }
    }

    M.proxy(true);
    if (isSimple === true) {
      window.mapJs.addPlugin(pluginList[0]);
      window.mapJs.addPlugin(pluginList[1]);
      window.mapJs.addPlugin(pluginList[3]);
      window.mapJs.addPlugin(pluginList[4]);
    } else {
      for (let i = 0; i < pluginList.length; i++) {
        window.mapJs.addPlugin(pluginList[i]);
      }

      window.mapJs.addPlugin(pluginEdition);
    }

    if(InsertPhotoFeatures.length>0){//añadir de vuelta features de InsertPhoto tras el borrado de destroy del mapJs.
      window.mapJs.getLayers().find(l=>l.impl_.name === 'insertPhoto').addFeatures(InsertPhotoFeatures);
    }

    if(window.mapJs.getPlugins().find(p => p.name === 'Mapaalacarta').controls_[0].eventsManager_.events_["added:map"]){
      window.mapJs.getPlugins().find(p => p.name === 'Mapaalacarta').controls_[0].eventsManager_.events_["added:map"].forEach(k=>window.mapJs.getPlugins().find(p => p.name === 'Mapaalacarta').controls_[0].unByKey("added:map",k.eventKey_));
    }
    pluginList[0].getControls()[0].on(M.evt.ADDED_TO_MAP, (evt) => {
      setTimeout(() => {//Espera para el plugin de Mapa a la Carta porque el dragEnd podría ser lanzado antes de que finalize de añadirse el layer25 y layer50
        if(!this.frameTranslateTimer || this.frameTranslateTimer>new Date().getTime()){
          this.onSetCoordinate(evt);
          this.onSetCenter(evt);
        }
      }, 100);
    }, this);
    setTimeout(() => {
      if (this.bboxApi.length === 4){
        this.translateFrame(null);
      }
    }, 150);

    window.mp = pluginList[3];
    this.addedSearchEventFunction = (extent) => {
      declare var ol;

      window.mapJs.getMapImpl().getLayers().getArray().forEach(l => {
        if (l.get('id') === 'frame_layer') {
          let polygon = ol.geom.Polygon.fromExtent(extent);
          let coords = polygon.getCoordinates()[0];
          let centerX = (coords[0][0] + coords[2][0]) / 2;
          let centerY = (coords[0][1] + coords[2][1]) / 2;
          let center = [centerX, centerY];

          const macPlugin = pluginList.find(p=>p.name==="Mapaalacarta");
          let frameCoords = macPlugin.getCoordinates()[1];
          let oldCenterX = (frameCoords[0][0] + frameCoords[2][0]) / 2;
          let oldCenterY = (frameCoords[0][1] + frameCoords[2][1]) / 2;
          let oldCenter = [oldCenterX, oldCenterY];

          let deltaX = center[0] - oldCenter[0];
          let deltaY = center[1] - oldCenter[1];
          macPlugin.translateAll(deltaX, deltaY);
        }
      })

      // ZOOM TO AREA OF IMPRESSION WHEN SEARCH USING IGN
      let scale = this.props.parentState.scale;
      let zoomToApply = 9;
      if (scale === "1:25.000" || scale === "1:30.000") {
        zoomToApply = 11;
      } else if (scale === "1:20.000") {
        zoomToApply = 12;
      } else {
        zoomToApply = 10;
      }

      window.mapJs.setZoom(zoomToApply);
    };
    pluginList[1].on('ignsearch:entityFound', this.addedSearchEventFunction);
    let key = pluginList.find(p => p.name === 'Mapaalacarta').on('dragend', (result) => {
      setTimeout(()=>{this.setModal(window.mapJs, this.props.parentState);},100);
    });

    this.addedLayerEventFunction = (layers) => {
      let funcFrame = (layer) => {
        if ((layer.type === 'KML' || layer.type === 'GeoJSON' || layer.type === 'GPX' || layer.type === 'Vector') && layer.from_parameters !== true && layer.impl_.name !== "searchresult") {
          setTimeout(() => {
            this.translateFrame(layer);//Si no se espera se trae el extent default incorrecto al haber usado plugin IGNSearch //Pero si no es instantaneo se vuelve a poner el Frame en el resultado de IGNSearch al volver, perdiendo su configuración antes de volver.
            //const {pluginList} = this.props;pluginList[0].setMapCenter(window.mapJs);//El zoom es a madrid aun que se ha movido a Cádiz por causa de IGNSearch
          }, 100);
        }
      };
      if(layers.forEach){
        layers.forEach(funcFrame);
      }else{
        funcFrame(layers);
      }
    };
    window.mapJs.on(M.evt.ADDED_LAYER, this.addedLayerEventFunction);

    window.mapJs.on(M.evt.COMPLETED, () => {
      if (drawFeatures !== null) {
        window.mapJs.getImpl().getLayers().forEach(layer => {
          if (layer.name === '__draw__') {
            layer.addFeatures(drawFeatures);
          }

        });
        window.mapJs.getLayers().find((l)=>{
          if(l.impl_.name === "__draw__"){l.refresh();return true;}
          return false;
        });
      }

      if (this.valuesApi.serie !== undefined && this.bboxApi.length === 4) {
        this.loadRoutes(this.valuesApi.serie, bbox, crs);
      }
    });

    this.setState({
      map: window.mapJs,
    }, function () {
      parentState.mapa = window.mapJs;
      parentState.zoom = 10;
      this.setStateGlobal({
        ...parentState,
        map: window.mapJs,
        zoom: 10,
        eventKey: key
      });
    }.bind(this));

    let fullViewMapControl = window.mapJs.impl_.controls_.find(c=>c.name==="FullViewMap");
    if(fullViewMapControl){
      this.generateProductScalePanel(fullViewMapControl);
    }
  }

  generateProductScalePanel(fvm){
    var mcontrolmcontainer = document.createElement('div'),tituloContenedor = document.createElement('div'),contenedorPadre = document.createElement('div');
    mcontrolmcontainer.className = 'm-control m-container';
    tituloContenedor.className = 'divTitulo'
    contenedorPadre.className = 'controlPadre'
    contenedorPadre.appendChild(tituloContenedor);
    mcontrolmcontainer.appendChild(contenedorPadre);

    var panelExtra = new window.M.ui.Panel('ProdScal', {
      "collapsible": false,"collapsedButtonClass": 'icon-target',
      "className": 'g-cartografia-producto-escala',"position": window.M.ui.position.BL
    });
    window.mapJs.addPanels(panelExtra);
    panelExtra.getControlsContainer().append(mcontrolmcontainer);

    if(fvm.auxFunc == null){//Avoid recursive error
      fvm.auxFunc = fvm.clickFullView_;
    }
    fvm.scaleMoveOnFullScreenToggle = (U)=>{
      if(U.target.classList[0]==="g-cartografia-cancelar"){
        window.tmp4.appendChild(window.tmp1);
        window.tmp4.appendChild(window.tmp2);
        window.tmp3.setAttribute("style", "display:flex");
      }
      if(U.target.classList[0]==="g-cartografia-tamano" && window.tmp1.parentElement.className === "divTitulo"){
        if(window.tmp0.querySelector('.TabsList')){//Series
          let tm = window.tmp0.children[1];
          let tm1 = tm.querySelector(".h2Custom.fullScreenScaleREF");
          tm.insertBefore(window.tmp1,tm1);
          tm.insertBefore(window.tmp2,tm1.nextSibling);
        }else{
          let tm1 = window.tmp0.querySelector(".h2Custom.fullScreenScaleREF");
          window.tmp0.insertBefore(window.tmp1,tm1);
          window.tmp0.insertBefore(window.tmp2,tm1.nextSibling);
        }
        window.tmp3.setAttribute("style", "display:none!important");
      }
    }
    fvm.clickFullView_ = (U)=>{
      window.tmp5 = {target:document.querySelector("#btnFullView")}
      fvm.auxFunc(U);
      fvm.scaleMoveOnFullScreenToggle(U);
    }
    document.addEventListener('fullscreenchange', (fs)=>{if(document.fullscreenElement == null && fs.target.className.includes("m-mapea-container")) fvm.scaleMoveOnFullScreenToggle(window.tmp5)});
    document.addEventListener('mozfullscreenchange', (fs)=>{if(document.mozFullScreenElement == null && fs.target.className.includes("m-mapea-container")) fvm.scaleMoveOnFullScreenToggle(window.tmp5)});
    document.addEventListener('webkitfullscreenchange', (fs)=>{if(document.webkitFullscreenElement == null && fs.target.className.includes("m-mapea-container")) fvm.scaleMoveOnFullScreenToggle(window.tmp5)});
    document.addEventListener('msfullscreenchange', (fs)=>{if(document.msFullscreenElement == null && fs.target.className.includes("m-mapea-container")) fvm.scaleMoveOnFullScreenToggle(window.tmp5)});
    window.tmp0 = document.querySelector(".panel-content");
    window.tmp1 = document.querySelector(".scale.first-step");
    window.tmp2 = document.querySelector(".scale.second-step");
    window.tmp3 = document.querySelector(".m-panel.g-cartografia-producto-escala");
    window.tmp4 = document.querySelector(".m-panel.g-cartografia-producto-escala .divTitulo");
    window.tmp3.setAttribute("style", "display:none!important");
  }

  loadRoutes = (serie, bbox, crs) => {
    let newBbox = bbox.split(',').map(elm => parseFloat(elm));
    if (crs !== 'EPSG:4258' && crs !== 'EPSG:4326') {
      const originProj = ol.proj.get(crs);
      const destProj = ol.proj.get('EPSG:4258');
      newBbox = ol.proj.transformExtent(newBbox, originProj, destProj);
    }

    const url = `${properties.ROUTE_CATALOGUE_URLS}?serie=${serie}&crs=4258&bbox=${newBbox.join(',')}`;
    const routesUrls = [];
    M.remote.get(url).then((request) => {
      const jsonRespuesta = JSON.parse(request.text);
      jsonRespuesta.resultado.forEach((layer) => {
        if (['CaminoDelCid_HITOS.kml', 'CaminosDeArteRupestre.kml', 'REAJ.kml'].indexOf(layer.Nombre) === -1) {
          routesUrls.push({ url: layer.rutaFtp, name: layer.Nombre, credits: layer.LicenciaES });
        }
      });

      routesUrls.forEach((route, index) => {
        const fileName = route.url.substring(route.url.lastIndexOf('/') + 1, route.url.lastIndexOf('.'));
        const extension = route.url.substring(route.url.lastIndexOf('.') + 1, route.url.length);
        M.remote.get(route.url).then((file) => {
          if (extension === 'geojson') {
            this.loadGeoJSONLayer_(file.text, fileName);
          } else if (extension === 'kml') {
            this.loadKMLLayer_(file.text, fileName, false, route.credits);
          }
        });
      });
    }).catch((err) => {
      console.error(err);
    });
  }

  onSetCoordinate(evt) {
    const { pluginList, parentState } = this.props;
    let scale = parentState.scale;
    let zoomToApply = 10;
    if (scale === "1:25.000" || scale === "1:30.000" || scale === "1:40.000" || scale === "1:50.000") {
      zoomToApply = 11;
    } else if (scale === "1:20.000") {
      zoomToApply = 12;
    } else if (scale === "1:10.000") {
      zoomToApply = 13;
    } else if (scale === "1:5.000") {
      zoomToApply = 14;
    } else if (scale === "1:2.500") {
      zoomToApply = 15;
    }

    setTimeout(() => {
      //if (parentState.active > 5) { parentState.seleccionadoProductoSeries === 'Foto' || parentState.seleccionadoProductoSeries === 'Poster'
      const auxName = parentState.seleccionadoProductoSeries === 'Elaborado' ? 'coordinates' : 'coordinatesPoster';
      if ((parentState[auxName] !== null || parentState[auxName] !== undefined) && parentState[auxName].length !== 0) {
        pluginList[0].setCoordinates(parentState[auxName], parentState.inforFeatureCoordinates, Number.parseFloat(parentState.selectedRow.substring(0,parentState.selectedRow.length-1))); // plugin Mapaalacarta
        if(parentState.center[0]) window.mapJs.setCenter(parentState.center[0]);
        window.mapJs.setZoom(zoomToApply);
      }
    }, 150);
  }

  onSetCenter(evt) {
    const {pluginList} = this.props;
    pluginList[0].setMapCenter(window.mapJs);

    if (this.bboxApi.length === 4){
      this.translateFrame(null);
    }

    //let i = window.mapJs.getMapImpl().getInteractions().getArray()[11];window.mapJs.getMapImpl().removeInteraction(i);//Comentado al desconocer que se tiene que quitar.
  }

  translateFrame(layer) {
    let featuresExtent;
    if (layer == null) {
      featuresExtent = this.bboxApi;
    } else {
      featuresExtent = layer.getFeaturesExtent();
    }

    if (featuresExtent !== null && featuresExtent !== undefined && featuresExtent.length > 0) {
      const {pluginList} = this.props;
      const macPlugin = pluginList.find(p=>p.name==="Mapaalacarta");
      const xFloat = parseFloat((featuresExtent[0] + featuresExtent[2]) / 2);
      const yFloat = parseFloat((featuresExtent[1] + featuresExtent[3]) / 2);

      try {
        const coordinatesArray = macPlugin.getCoordinates()[1];
        const x0 = coordinatesArray[0][0];
        const x2 = coordinatesArray[2][0];
        const y0 = coordinatesArray[0][1];
        const y2 = coordinatesArray[2][1];
        const centerX = parseFloat((x0 + x2) / 2);
        const centerY = parseFloat((y0 + y2) / 2);
        const deltaX = xFloat - centerX;
        const deltaY = yFloat - centerY;
        macPlugin.translateAll(deltaX, deltaY)
        this.frameTranslateTimer = new Date().getTime()+2000;//Tiempo para el caso de regenerado
        if (layer === null) {
          window.mapJs.setBbox(this.bboxApi);
          window.mapJs.setZoom(11);
        }
      } catch (err) {}
    }
  }

  onSetFrameLayer = (extent) => {
    declare var ol;
    window.mapJs.getMapImpl().getLayers().getArray().forEach(l => {
      if (l.get('id') === 'frame_layer') {
        let polygon = ol.geom.Polygon.fromExtent(extent);
        let coords = polygon.getGeometry().getCoordinates();
        let centerX = (coords[0][0] - coords[2][0]) / 2;
        let centerY = (coords[0][1] - coords[2][1]) / 2;
        let center = [centerX, centerY];
        for (let i = 0; i < l.getSource().getFeatures(); i++) {
          l.getSource().getFeatures()[i].getGeometry().setCenter(center);
        }
      }
    });
  }

  loadGeoJSONLayer_ = (source2, layerName) => {
    let features = new ol.format.GeoJSON().readFeatures(source2, { featureProjection: window.mapJs.getProjection().code });
    const auxEditionTool = window.mapJs.getPlugins().find(p => p.name === "EditionTools");
    features.forEach((feature) => {
      if (feature.getProperties().style === undefined || feature.getProperties().style === null) {
        if (feature.getGeometry().getType() !== 'Point' && feature.getGeometry().getType() !== 'MultiPoint') {
          const style1 = new ol.style.Style({
            stroke: new ol.style.Stroke({ color: '#0000FF', width: 3 }),
            fill: new ol.style.Fill({ color: 'rgba(0, 0, 255, 0.2)' }),
          });
          feature.setStyle(style1);
          feature.realStyle = {
            stroke_width: 3,
          };
          if (auxEditionTool) {
            feature.styleFunction_ = auxEditionTool.dinamicStyleLineOrPolygon;
          }
          
        } else {
          const style2 = new ol.style.Style({
            image: new ol.style.Circle({
              radius: 6,
              stroke: new ol.style.Stroke({
                color: 'white',
                width: 2,
              }),
              fill: new ol.style.Fill({
                color: '#7CFC00',
              }),
            }),
          });
          feature.setStyle(style2);
          feature.realStyle = {
            image: {
              radius: 6,
              stroke_width: 2,
            },
          };
          if (auxEditionTool) {
            feature.styleFunction_ = auxEditionTool.dinamicStylePoint;
          }
        }
      } else {
        const featureStyle = Array.isArray(feature.getProperties().style) ? feature.getProperties().style[0] : feature.getProperties().style;
        let importedStyle;
        if (feature.getGeometry().getType() === 'Point' || feature.getGeometry().getType() === 'MultiPoint') {
          if (!M.utils.isNullOrEmpty(featureStyle.image_) && M.utils.isNullOrEmpty(featureStyle.image_.fill_)) {
            importedStyle = new ol.style.Style({
              image: new ol.style.Icon({
                src: featureStyle.image_.iconImage_.src_,
                size: featureStyle.image_.iconImage_.size_,
              }),
            });
            feature.set('icon', feature.getProperties().icon);
            feature.set('color', feature.getProperties().color);
            feature.set('size', feature.getProperties().size);
            feature.realStyle = {
              scale: true,
              image: {
                radius: feature.getProperties().size,
                stroke_width: 2,
              },
            };
            if (auxEditionTool) {
              feature.styleFunction_ = auxEditionTool.dinamicStylePoint;
            }
          } else if (!M.utils.isNullOrEmpty(featureStyle.image_)) {
            importedStyle = new ol.style.Style({
              image: new ol.style.Circle({
                radius: featureStyle.image_.radius_,
                fill: new ol.style.Fill({ color: featureStyle.image_.fill_.color_ }),
                stroke: new ol.style.Stroke({ color: featureStyle.image_.stroke_.color_, width: featureStyle.image_.stroke_.width_ }),
              }),
            });
            feature.realStyle = {
              image: {
                radius: featureStyle.image_.radius_,
                stroke_width: featureStyle.image_.stroke_.width_ ,
              },
            };
            if (auxEditionTool) {
              feature.styleFunction_ = auxEditionTool.dinamicStylePoint;
            }
          } else if (!M.utils.isNullOrEmpty(featureStyle.text_)) {
            importedStyle = new ol.style.Style({
              text: new ol.style.Text({
                text: featureStyle.text_.text_,
                font: featureStyle.text_.font_,
                fill: new ol.style.Fill({ color: featureStyle.text_.fill_.color_ }),
              }),
              stroke: new ol.style.Stroke({ color: 'rgba(213, 0, 110, 0)', width: 0 }),
              fill: new ol.style.Fill({ color: 'rgba(213, 0, 110, 0)' }),
            });
            feature.realStyle = { text: true };
            if (auxEditionTool) {
              feature.styleFunction_ = auxEditionTool.dinamicStyleText;
            }
          }

          if (!M.utils.isNullOrEmpty(importedStyle)) {
            feature.setStyle(importedStyle);
          }
        } else {
          if (M.utils.isNullOrEmpty(featureStyle.stroke_.lineDash_)) {
            importedStyle = new ol.style.Style({
              fill: new ol.style.Fill({ color: featureStyle.fill_.color_ }),
              stroke: new ol.style.Stroke({
                color: featureStyle.stroke_.color_,
                width: featureStyle.stroke_.width_,
              }),
            });
            feature.realStyle = {
              stroke_width: featureStyle.stroke_.width_,
            };
          } else {
            importedStyle = new ol.style.Style({
              fill: new ol.style.Fill({ color: featureStyle.fill_.color_ }),
              stroke: new ol.style.Stroke({
                color: featureStyle.stroke_.color_,
                width: featureStyle.stroke_.width_,
                lineDash: featureStyle.stroke_.lineDash_,
              }),
            });
            feature.realStyle = {
              stroke_width: featureStyle.stroke_.width_,
            };
          }

          if (featureStyle.stroke_.dashStyle !== undefined && featureStyle.stroke_.dashStyle !== null) {
            feature.set('dashStyle', featureStyle.stroke_.dashStyle);
          }
          const auxDashStyle = feature.get('dashStyle');
          if (auxDashStyle) {
            if (auxDashStyle !== 'solid') {
              feature.realStyle.dash = { type: auxDashStyle, sizes: featureStyle.stroke_.lineDash_ };
            }
          }

          feature.setStyle(importedStyle);
          if (auxEditionTool) {
            feature.styleFunction_ = auxEditionTool.dinamicStyleLineOrPolygon;
          }
        }
      }
    });

    features = this.convertToMFeature_(features);
    this.createLayer_(layerName, features);
    return features;
  }

  loadKMLLayer_ = (source, layerName, extractStyles, credits) => {
    let features = new ol.format.KML({ extractStyles }).readFeatures(source, { featureProjection: window.mapJs.getProjection().code });
    const auxEditionTool = window.mapJs.getPlugins().find(p => p.name === "EditionTools");
    features.forEach((feature) => {
      if (feature.getGeometry().getType() !== 'Point' && feature.getGeometry().getType() !== 'MultiPoint') {
        const style1 = new ol.style.Style({
          stroke: new ol.style.Stroke({ color: '#0000FF', width: 3 }),
          fill: new ol.style.Fill({ color: 'rgba(0, 0, 255, 0.2)' }),
        });
        feature.setStyle(style1);
        feature.realStyle = {
          stroke_width: 3,
        };
        if (auxEditionTool) {
          feature.styleFunction_ = auxEditionTool.dinamicStyleLineOrPolygon;
        }
      } else {
        const style2 = new ol.style.Style({
          image: new ol.style.Circle({
            radius: 6,
            stroke: new ol.style.Stroke({
              color: 'white',
              width: 2,
            }),
            fill: new ol.style.Fill({
              color: '#7CFC00',
            }),
          }),
        });
        feature.setStyle(style2);
        feature.realStyle = {
          image: {
            radius: 6,
            stroke_width: 2,
          },
        };
        if (auxEditionTool) {
          feature.styleFunction_ = auxEditionTool.dinamicStylePoint;
        }
      }
    });

    features = this.convertToMFeature_(features);
    this.createLayer_(layerName, features, credits);
    return features;
  }

  centerFeatures_ = (features) => {
    if (!M.utils.isNullOrEmpty(features)) {
      if (features.length > 1 || (features[0].getImpl().getOLFeature().getGeometry().getType() !== 'Point' && features[0].getImpl().getOLFeature().getGeometry().getType() !== 'MultiPoint')) {
        const extent = M.impl.utils.getFeaturesExtent(features);
        setTimeout(() => {
          window.mapJs.getMapImpl().getView().fit(extent, {
            duration: 500,
            minResolution: 1,
          });
        }, 1000);
      } else {
        window.mapJs.setCenter(features[0].getImpl().getOLFeature().getGeometry().getCoordinates());
      }
    }
  }

  createLayer_ = (layerName, features, credits) => {
    const layer = new M.layer.Vector({
      name: layerName,
    }, { displayInLayerSwitcher: true });
    layer.addFeatures(features);
    layer.setZIndex(9999);
    layer.from_parameters = true;
    window.mapJs.addLayers(layer);
    const layer2 = window.mapJs.getImpl().getLayers().find(layer => layer.name === layerName);
    layer2.getImpl().getOL3Layer().set('vendor.mapaalacarta.selectable', true);
    if (!M.utils.isNullOrEmpty(credits)) {
      layer2.getImpl().getOL3Layer().set('credits', credits);
    }

    if (document.getElementById('m-button-undoFeature') !== null) {
      document.getElementById('m-button-undoFeature').classList.remove('m-button-editionTools-disabled');
      document.getElementById('m-button-undoFeature').disabled = false;
    }

    if (document.getElementById('m-button-deleteFeature') !== null) {
      document.getElementById('m-button-deleteFeature').classList.remove('m-button-editionTools-disabled');
      document.getElementById('m-button-deleteFeature').disabled = false;
    }

    if (document.getElementById('m-button-editFeature') !== null) {
      document.getElementById('m-button-editFeature').classList.remove('m-button-editionTools-disabled');
      document.getElementById('m-button-editFeature').disabled = false;
    }

    if (document.getElementById('m-button-pickfeature') !== null) {
      document.getElementById('m-button-pickfeature').classList.remove('m-button-editionTools-disabled');
      document.getElementById('m-button-pickfeature').disabled = false;
    }

    if (document.getElementById('m-button-moveFeature') !== null) {
      document.getElementById('m-button-moveFeature').classList.remove('m-button-editionTools-disabled');
      document.getElementById('m-button-moveFeature').disabled = false;
    }

    if (document.getElementById('m-button-addlegend') !== null) {
      document.getElementById('m-button-addlegend').classList.remove('m-button-editionTools-disabled');
      document.getElementById('m-button-addlegend').disabled = false;
    }
  }

  convertToMFeature_ = (features) => {
    if (features instanceof Array) {
      return features.map((olFeature) => {
        const { geometry, ...restOfProp } = olFeature.getProperties(); // Impedir error de Geometría fantasma
        const feature = new M.Feature(olFeature.getId(), {
          geometry: {
            coordinates: geometry.getCoordinates(),
            type: geometry.getType(),
          },
          properties: restOfProp,
        });
        feature.getImpl().getOLFeature().setStyle(olFeature.getStyle());
        const oldName = feature.getAttribute('name');
        feature.setAttribute('name', (oldName + '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').split('\'').join(''));
        if (olFeature.realStyle) {
          feature.getImpl().getOLFeature().realStyle = olFeature.realStyle;
          feature.getImpl().getOLFeature().styleFunction_ = olFeature.styleFunction_;
        }
        return feature;
      });
    }
  }

  componentWillUnmount(){
    window.mapJs.eventsManager_.remove(M.evt.ADDED_LAYER, this.addedLayerEventFunction);
    this.props.pluginList[1].eventsManager_.remove('ignsearch:entityFound', this.addedSearchEventFunction); // ignsearch plugin
  }

  render() {
    return (<div id="map" className="map"></div>)
  }
}

export default Map;
